module.exports = __webpack_public_path__ + "img/Decentralized.f0c2d2f9.png";